import NavbarTablet from "../../navbar/components/NavbarTablet";

// Corregí el uso de children: se usa {children} directamente en lugar de <Children/>
// porque children es un nodo React, no un componente.
export default function LayoutTablet({children}) {
  const DEBUG = process.env.NODE_ENV === 'development';

  return (
    <div className='LayoutTablet w-full overflow-hidden'>
      {DEBUG && <div className='text-white text-center bg-red-900'>tablet</div>}
      <NavbarTablet/>
      {children}
    </div>
  )
}